import { type QueryKeyRoot } from '../queryKeyRoots';

export const USER_QUERY_KEYS = {
  user: () => ['user'] as const satisfies readonly [QueryKeyRoot, ...unknown[]],
} as const;
